import {
  changePaymentMethodError,
  changePaymentMethodSuccess,
  closeCreditCardModal,
  fetchPaymentMethods as fetchPaymentMethodsAction,
  fetchPaymentMethodsError,
  fetchPaymentMethodsSuccess,
  showCCUpdatedNotification,
  showChangePaymentNotificationError,
  showChangePaymentNotificationSuccess,
} from '~/actions/billing.actions';
import { ActionKeys } from '~/actions/constants';
import { AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getNewPaymentType, showCreditCardModal } from '~/selectors/billing.selectors';
import { apiChangePaymentMethod, apiFetchPaymentMethods } from '~/services/billing.service';
import { ChangePaymentMethodPayload, fromJSON, PaymentMethodsJson } from '~/types/PaymentMethods';
import { getCookie } from '~/utils/cookies';
import { selectState } from '..';

export function* billingCloseCreditCardModal() {
  const isCreditCardModalVisible: ReturnType<typeof showCreditCardModal> =
    yield selectState<ReturnType<typeof showCreditCardModal>>(showCreditCardModal);
  if (isCreditCardModalVisible) {
    yield put(showCCUpdatedNotification());
  }
  yield put(closeCreditCardModal());
  yield put(fetchPaymentMethodsAction());
}

export function* fetchPaymentMethods() {
  try {
    const response: AxiosResponse<PaymentMethodsJson> = yield call(apiFetchPaymentMethods);
    yield put(fetchPaymentMethodsSuccess(fromJSON(response.data)));
  } catch (err) {
    yield put(fetchPaymentMethodsError());
  }
}

export function* changePaymentMethod() {
  try {
    const trackerSessionId = getCookie('tracker_sessionid') || '';
    const isImpersonatingCookie = getCookie('is_impersonate') || '';

    const newPaymentType: ReturnType<typeof getNewPaymentType> =
      yield selectState<ReturnType<typeof getNewPaymentType>>(getNewPaymentType);

    const payload: ChangePaymentMethodPayload = {
      action: {
        type: 'payment_method_change',
        payment_method: {
          type: newPaymentType!,
        },
        is_impersonate: isImpersonatingCookie === 'true',
        tracker_sessionid: trackerSessionId,
      },
    };
    const response: AxiosResponse<PaymentMethodsJson> = yield call(apiChangePaymentMethod, payload);
    yield put(fetchPaymentMethodsSuccess(fromJSON(response.data)));
    yield put(changePaymentMethodSuccess());
    yield put(showChangePaymentNotificationSuccess());
  } catch (err) {
    yield put(changePaymentMethodError());
    yield put(showChangePaymentNotificationError());
  }
}

export default [
  takeLatest(ActionKeys.USER_FETCH_SUCCESS, billingCloseCreditCardModal),
  takeLatest(ActionKeys.FETCH_PAYMENT_METHODS, fetchPaymentMethods),
  takeLatest(ActionKeys.PAYMENT_METHOD_CHANGE, changePaymentMethod),
];
